import React from "react";
import { Select, Form, Icon, Input, Button, Row, Col, DatePicker } from "antd";
import { withNamespaces } from "react-i18next";
import FileLink from "../FileLink/FileLink";

const { Option } = Select;

const ConsentLhsStep2 = (props) => {
  return (
    <div className="form-group">
      <div className="form-group-details">
        <h4>
          {props.i18n.t(
            "NamespaceConsentLhsStep2:Subject Found! Please verify details below"
          )}
          :
        </h4>
        {props.siteID && (
          <h5>
            {props.i18n.t("Site ID")}: <b>{props.siteID}</b>
          </h5>
        )}
        {props.userID && (
          <h5>
            {props.i18n.t("User ID")}: <b>{props.userID}</b>
          </h5>
        )}
        <h5>
          {props.i18n.t("Subject ID")}: <b>{props.subjectID}</b>
        </h5>

        <h5>
          {props.i18n.t("Consent Exists")}:{" "}
          <b>{props.consentExists === true ? "Yes" : "No"}</b>
        </h5>

        {props.consentExists && (
          <div className="consent-exists">
            <h5>
              {props.i18n.t("Consent Date")}: <b>{props.consentExistsDate}</b>
            </h5>
            <h5>
              {props.i18n.t("Consent Type")}: <b>{props.consentExistsType}</b>
            </h5>
            <h5>
              {props.i18n.t("Consent Person")}:{" "}
              <b>{props.consentExistsPersonType}</b>
            </h5>
            <h5>
              {props.i18n.t("Consent Method")}:{" "}
              <b>{props.consentExistsMethodType}</b>
            </h5>
            {[
              "WithdrawConsentEmail",
              "Email",
              "EmailRegainedCapacity",
            ].includes(props.consentExistsMethodType) &&
              props.consentExistsEmailStatus && (
                <h5>
                  {props.i18n.t(
                    "NamespaceConsentLhsStep2:Consent Email Status"
                  )}
                  : <b>{props.consentExistsEmailStatus.replace(/_/g, " ")}</b>
                </h5>
              )}

            {props.consentExistsLink &&
              (Array.isArray(props.consentExistsLink) ? (
                props.consentExistsLink.map(({ link, name }) => (
                  <h5 key={name}>
                    {props.i18n.t("Document Link")}:{" "}
                    <b style={{ position: "relative", top: "8px" }}>
                      <FileLink url={link} text={name} />
                    </b>
                  </h5>
                ))
              ) : (
                <h5>
                  {props.i18n.t("Document Link")}:{" "}
                  <b>
                    <a href={props.consentExistsLink.link} target="_blank">
                      {props.consentExistsLink.name}
                    </a>
                  </b>
                </h5>
              ))}
          </div>
        )}
      </div>

      <Form.Item>
        <label>
          <span className="form-label">
            {props.i18n.t(
              "NamespaceConsentLhsStep2:Who will be providing Consent?"
            )}
          </span>
          {props.form.getFieldDecorator("consentPersonType", {
            initialValue:
              props.consentPersonType || props.consentExistsPersonType,
            rules: [
              {
                required: true,
                message: props.i18n.t(
                  "NamespaceConsentLhsStep2:Please select who will be providing consent"
                ),
              },
            ],
          })(
            <Select>
              <Option value="Patient" disabled={!(props.has_rand_plat_step_3_participant_after_deferral || props.has_rand_plat_step_3_regained_capacity_after_deferral
                || props.has_randomization_platform_step_3_deferred || props.has_randomization_platform_step_3_patient
                || props.has_randomization_platform_step_3_patient_regained_capacity || props.has_randomization_platform_step_3_withdraw)}>{props.i18n.t("Patient")}</Option>
              <Option value="Surrogate" disabled={!(props.has_rand_plat_step_3_surrogate_after_deferral || props.has_randomization_platform_step_3_surrogate)}>{props.i18n.t("Surrogate")}</Option>
              <Option value="Emergency" disabled={!(props.has_rand_plat_step_3_emergency)}>{props.i18n.t("Emergency")}</Option>
            </Select>
          )}
        </label>
      </Form.Item>

      <Form.Item>
        <label>
          <span className="form-label">{props.i18n.t("Consent Type")}</span>
          {props.form.getFieldDecorator("consentMethodType", {
            initialValue: props.consentExistsMethodType,
            rules: [
              {
                required: true,
                message: props.i18n.t(
                  "NamespaceConsentLhsStep2:Please select the type of consent desired"
                ),
              },
            ],
          })(
            <Select>
              <Option value="Electronic">
                {props.i18n.t("NamespaceConsentLhsStep2:Electronic Consent")}
              </Option>
              <Option value="Paper">
                {props.i18n.t("NamespaceConsentLhsStep2:Paper Consent")}
              </Option>
              {!props.consentRandomization && props.form.getFieldValue("consentPersonType") !== "Emergency" && (
                <Option value="Email">
                  {props.i18n.t("NamespaceConsentLhsStep2:E-mail Consent")}
                </Option>
              )}
              {!props.consentRandomization && props.form.getFieldValue("consentPersonType") === "Patient" && (
                <Option value="RegainedCapacity">
                  {props.i18n.t(
                    "NamespaceConsentLhsStep2:Regained Capacity Electronic"
                  )}
                </Option>
              )}
              {!props.consentRandomization && props.form.getFieldValue("consentPersonType") === "Patient" && (
                <Option value="EmailRegainedCapacity">
                  {props.i18n.t(
                    "NamespaceConsentLhsStep2:Regained Capacity Email"
                  )}
                </Option>
              )}
              {!props.consentRandomization && props.form.getFieldValue("consentPersonType") === "Patient" && (
                <Option value="RegainedCapacityPaper">
                  {props.i18n.t(
                    "NamespaceConsentLhsStep2:Regained Capacity Paper"
                  )}
                </Option>
              )}


              {/* props.consentExistsPersonType === 'Emergency' &&   */}
              {!props.consentRandomization && ["Patient", "Surrogate"].includes(props.form.getFieldValue("consentPersonType")) && (
                <Option value="AfterDeferralElectronic">
                  {props.i18n.t(
                    "NamespaceConsentLhsStep2:After Deferral Electronic"
                  )}
                </Option>
              )}
              {!props.consentRandomization && ["Patient", "Surrogate"].includes(props.form.getFieldValue("consentPersonType")) && (
                <Option value="AfterDeferralEmail">
                  {props.i18n.t(
                    "NamespaceConsentLhsStep2:After Deferral Email"
                  )}
                </Option>
              )}
              {!props.consentRandomization && ["Patient", "Surrogate"].includes(props.form.getFieldValue("consentPersonType")) && (
                <Option value="AfterDeferralPaper">
                  {props.i18n.t(
                    "NamespaceConsentLhsStep2:After deferral Paper"
                  )}
                </Option>
              )}

              {!props.consentRandomization && ["Patient", "Surrogate"].includes(props.form.getFieldValue("consentPersonType")) && (
                <Option value="RegainedCapacityAfterDeferralElectronic">
                  {props.i18n.t(
                    "NamespaceConsentLhsStep2:Regained Capacity After Deferral Electronic"
                  )}
                </Option>
              )}
              {!props.consentRandomization && ["Patient", "Surrogate"].includes(props.form.getFieldValue("consentPersonType")) && (
                <Option value="RegainedCapacityAfterDeferralEmail">
                  {props.i18n.t(
                    "NamespaceConsentLhsStep2:Regained Capacity After Deferral Email"
                  )}
                </Option>
              )}
              {!props.consentRandomization && ["Patient", "Surrogate"].includes(props.form.getFieldValue("consentPersonType")) && (
                <Option value="RegainedCapacityAfterDeferralPaper">
                  {props.i18n.t(
                    "NamespaceConsentLhsStep2:Regained Capacity After Deferral Paper"
                  )}
                </Option>
              )}

              {/*{props.form.getFieldValue('consentPersonType') === 'Patient' && <Option value="WithdrawConsentElectronic">{props.i18n.t('NamespaceConsentLhsStep2:Withdraw Consent Electronic')}</Option>}
              {props.form.getFieldValue('consentPersonType') === 'Patient' && <Option value="WithdrawConsentPaper">{props.i18n.t('NamespaceConsentLhsStep2:Withdraw Consent Paper')}</Option>}
              {props.form.getFieldValue('consentPersonType') === 'Patient' && <Option value="WithdrawConsentEmail">{props.i18n.t('NamespaceConsentLhsStep2:Withdraw Consent Email')}</Option>}*/}
            </Select>
          )}
        </label>
      </Form.Item>

      <Form.Item>
        <label>
          <span className="form-label">
            {props.i18n.t(
              "NamespaceConsentLhsStep2:Please indicate approval to start the consenting process"
            )}
          </span>
          {props.form.getFieldDecorator("consent_overwrite", {
            rules: [
              {
                required: true,
                message: props.i18n.t(
                  "NamespaceConsentLhsStep2:You need to agree to override data if you wish to proceed with this entry!"
                ),
              },
            ],
          })(
            <Select>
              <Option value="yes">{props.i18n.t("Yes")}</Option>
              <Option value="">{props.i18n.t("No")}</Option>
            </Select>
          )}
        </label>
      </Form.Item>
    </div>
  );
};

export default withNamespaces()(ConsentLhsStep2);



// WEBPACK FOOTER //
// ./src/components/ConsentTypeLhs/ConsentLhsStep2.js